// Phase I3 — Tier strip.
// Above-verdict band: TIER · LEGS · ODDS-TARGET on the left;
// CONTRADICTION / ADVERSARIAL / CORRELATION badges on the right.

import { Badge } from "../../../components/super-acca";
import { TIERS } from "../../../super-acca/categories";
import type { SuperAccaSlip } from "../../../super-acca/view-models";

export interface TierStripProps {
  slip: SuperAccaSlip;
  /** Adversarial cleared count — number of cleared legs to render in the badge. */
  clearedCount?: number;
  totalLegs?: number;
}

export function TierStrip({ slip, clearedCount, totalLegs }: TierStripProps) {
  const tier = TIERS[slip.tier];
  const cleared = clearedCount ?? slip.legs.filter((l) => !l.flagged).length;
  const total = totalLegs ?? slip.legs.length;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "12px 18px",
        background: "var(--sa-bg-raised)",
        border: "1px solid var(--sa-hairline)",
        borderBottom: "none",
        borderRadius: "8px 8px 0 0",
        flexWrap: "wrap",
        gap: 12,
      }}
    >
      <div style={{ display: "flex", gap: 16, alignItems: "center" }}>
        <span
          style={{
            fontFamily: "var(--sa-font-mono)",
            fontSize: 10,
            color: "var(--sa-fg-muted)",
            letterSpacing: "0.2em",
          }}
        >
          TIER
        </span>
        <span
          style={{
            fontFamily: "var(--sa-font-stat)",
            fontSize: 22,
            color: "var(--sa-accent-saffron)",
            letterSpacing: "0.04em",
          }}
        >
          {tier.label}
        </span>
        <span
          style={{
            fontFamily: "var(--sa-font-mono)",
            fontSize: 10.5,
            color: "var(--sa-fg-secondary)",
          }}
        >
          {slip.legs.length} LEGS · {tier.odds_target}
        </span>
      </div>
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
        {slip.contradiction_passed ? (
          <Badge variant="success">CONTRADICTION · CLEARED</Badge>
        ) : null}
        {slip.adversarial_cleared ? (
          <Badge variant="success">
            ADVERSARIAL · {cleared}/{total} CLEARED
          </Badge>
        ) : null}
        {slip.correlation_applied ? (
          <Badge variant="amber">CORRELATION · APPLIED</Badge>
        ) : null}
      </div>
    </div>
  );
}
